import React, { useEffect, useMemo, useState } from "react";
import { getLogs } from "../utils/api";
import "./../styles.css";

export default function Devices() {
  const [rows, setRows] = useState([]);
  const [qrFilterText, setQrFilterText] = useState("");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [qrSel, setQrSel] = useState(""); // QR-Dropdown
  const [loading, setLoading] = useState(false);
  const [justRefreshed, setJustRefreshed] = useState(false); // Flash für Button

  async function load() {
    setLoading(true);
    try {
      const logs = await getLogs(120); // mehr Einträge => aktueller
      const norm = (logs || []).map((s) => {
        const ua = (s.userAgent || "").toLowerCase();
        const os =
          s.os ||
          (ua.includes("android")
            ? "Android"
            : ua.match(/iphone|ipad|mac|ios|apple/)
            ? "Apple"
            : "Unknown");
        const device =
          s.device || (os === "Android" ? "Android" : os === "Apple" ? "iOS" : "Desktop");

        return {
          ...s,
          os,
          device,
          scanId: s.scanId || s.scandId || s.qrCode || s.key || "unknown",
          city: s.city || s.geo?.city || "",
          country: s.country || s.geo?.country || "",
        };
      });
      setRows(norm);

      // kurzer grüner Flash, wenn die Aktualisierung durch ist
      setJustRefreshed(true);
      setTimeout(() => setJustRefreshed(false), 800);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    load();
    const i = setInterval(load, 15000); // Auto-Refresh
    return () => clearInterval(i);
  }, []);

  // QR-Optionen (live)
  const qrOptions = useMemo(() => {
    const map = new Map();
    for (const r of rows) {
      const k = r.scanId || "unknown";
      map.set(k, (map.get(k) || 0) + 1);
    }
    return Array.from(map.entries())
      .map(([code, count]) => ({ code, count }))
      .sort((a, b) => a.code.localeCompare(b.code));
  }, [rows]);

  const filtered = useMemo(() => {
    return rows.filter((d) => {
      const qrDropOk = !qrSel || d.scanId === qrSel; // Dropdown
      const qrTextOk = qrFilterText
        ? String(d.scanId).toLowerCase().includes(qrFilterText.toLowerCase())
        : true; // Text
      const t = d.timestamp ? new Date(d.timestamp).getTime() : 0;
      const fromOk = dateFrom ? t >= new Date(dateFrom).getTime() : true;
      const toOk = dateTo ? t <= new Date(dateTo).getTime() : true;
      return qrDropOk && qrTextOk && fromOk && toOk;
    });
  }, [rows, qrSel, qrFilterText, dateFrom, dateTo]);

  return (
    <div className="page">
      <h2>📱 Geräte-Scans</h2>

      {/* hübscher, einheitlicher Filter-Container */}
      <div className="filter-card" style={{ marginBottom: 12 }}>
        <button
          className={`btn btn--primary ${justRefreshed ? "btn--flash" : ""}`}
          onClick={load}
          disabled={loading}
          title="Neu laden"
        >
          {loading ? "Aktualisiere…" : "Aktualisieren"}
        </button>

        <select
          className="select"
          value={qrSel}
          onChange={(e) => setQrSel(e.target.value)}
          title="QR-Code auswählen"
        >
          <option value="">Alle QR-Codes</option>
          {qrOptions.map(({ code, count }) => (
            <option key={code} value={code}>
              {code} ({count})
            </option>
          ))}
        </select>

        <button
          className="btn"
          onClick={() => { setQrSel(""); setQrFilterText(""); setDateFrom(""); setDateTo(""); }}
          title="Filter zurücksetzen"
        >
          Alle QR-Codes
        </button>

        <input
          className="input"
          placeholder="QR-Code (Text) filtern…"
          value={qrFilterText}
          onChange={(e) => setQrFilterText(e.target.value)}
        />
        <input className="input" type="date" value={dateFrom} onChange={(e) => setDateFrom(e.target.value)} />
        <input className="input" type="date" value={dateTo} onChange={(e) => setDateTo(e.target.value)} />
      </div>

      <div className="table-wrap">
        <table className="table">
          <thead>
            <tr>
              <th>Gerät</th>
              <th className="hide-sm">OS</th>
              <th>QR-Code</th>
              <th>Ort</th>
              <th className="hide-sm">Zeit</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((d, i) => (
              <tr key={i}>
                <td data-label="Gerät">{d.device}</td>
                <td data-label="OS" className="hide-sm">{d.os}</td>
                <td data-label="QR-Code">{d.scanId}</td>
                <td data-label="Ort">{[d.city, d.country].filter(Boolean).join(", ") || "?"}</td>
                <td data-label="Zeit" className="hide-sm">{d.timestamp}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {filtered.length === 0 && (
        <div className="empty">Keine Einträge mit diesem Filter.</div>
      )}
    </div>
  );
}
